<app-title title="Estamos aqui para ajudar você"></app-title>
<div style="width: 100%; background: #f7f7f7;">
  <div class="container-financie">

    <div class="right-first" style="justify-content: start!important;">
      <img src="../../assets/contato/contato_red2.jpg" alt="" />
    </div>

    <div class="right">
      <div class="content-ajuda">
        <div class="titulo">
          <h2 class="titulo-ajuda">
            Precisa de ajuda?<br>
            Fale com nosso time:
          </h2>

          <div style="width: 100%; display: flex; justify-content: center; ">
            <button class="btn2 btn-success" style="display: flex; margin:15px; align-items: center; gap: 8px;"
              type="button" (click)="openWhatsApp()">
              <i class="fab fa-whatsapp"></i>
              Fale com um consultor
            </button>
          </div>
          <div style="display: flex; align-items: center; text-align: center;">
            <hr style="flex: 1; border: none; height: 1px; background-color: #ccc;">
            <span style="padding: 0 10px; color: #272727 ">ou</span>
            <hr style="flex: 1; border: none; height: 1px; background-color: #ccc;">
          </div>

          <div class="form-container">
            <form [formGroup]="form" (ngSubmit)="enviar()">
              <!-- Nome -->
              <div class="form-group">
                <label for="nome">Nome</label>
                <input type="text" id="nome" placeholder="Nome Completo" formControlName="nome" />
                <small class="error" *ngIf="submitted && f.nome.invalid">Nome é obrigatório.</small>
              </div>

              <!-- Nome -->
              <div class="form-group">
                <label for="nome">E-mail</label>
                <input type="email" id="email" placeholder="Coloque seu e-mail" formControlName="email" />
                <small class="error" *ngIf="submitted && f.email.errors?.['required']">E-mail é obrigatório.</small>
                <small class="error" *ngIf="submitted && f.email.errors?.['email']">E-mail inválido.</small>
              </div>

              <!-- Telefone -->
              <div class="form-group">
                <label for="telefone">Telefone</label>
                <input type="form-control" id="telefone" placeholder="Informe seu telefone" formControlName="telefone"
                  mask="(00) 00000-0000" />
                <small class="error" *ngIf="submitted && f.nome.invalid">Telefone é obrigatório.</small>
              </div>

              <!-- Campo de dúvida -->
              <div class="form-group full-width">
                <label for="duvida">Qual sua dúvida?</label>
                <textarea id="duvida" name="duvida" formControlName="texto" rows="3" cols="50"
                  style="border: none; margin:5px;" required></textarea>
                <small class="error" *ngIf="submitted && f.texto.invalid">Texto é obrigatório.</small>

              </div>

              <div class="buttons">
                <button type="submit" class="btn btn-primary" [disabled]="isLoading">
                  <span *ngIf="isLoading" class="spinner"></span>
                  <span *ngIf="!isLoading">Enviar</span>
                  <span *ngIf="isLoading">Enviando...</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-title title="Veja onde podemos te atender"></app-title>

  <app-lojas></app-lojas>

</div>